/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import styled, { keyframes } from 'styled-components';
import { _ } from '_locales';
import { isArraysEqual } from '../helpers';
import eventTracker from '../../../helpers/eventTracker';
import events from '../events';

import {
  Poll,
  Quiz
} from './wwtkActivities';

const Container = styled.div`
  flex: 1;
  width: 100%;
  box-sizing: border-box;
  background-color: white;
  border-radius: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
`;

const Title = styled.h2`
  font-size: 18px !important;
  color: rgba(64, 64, 64, 1);
  font-weight: 700 !important;
  border-bottom: 2px solid #E7ECEF;
  padding-bottom: 10px;
  padding-left:10px;
  padding-top: 13px;
  margin-bottom: 0px;
  text-align: left !important;
`;

const Context = styled.div`
  padding: 10px 15px;
  padding-top: 0;
`;

const OpacityAnimation = keyframes`
  from {opacity: 0};
  to {opacity: 1}
`;

const FinishText = styled.div`
  margin-bottom: 20px;
  animation: ${OpacityAnimation} 0.7s;
  text-align: left !important;
`;

/**
 * Activities components object
 */
const activities = {
  poll: (props) => (<Poll {...props} />),
  quiz: (props) => (<Quiz {...props} />)
};

const WWTK = ({
  wwtkItems,
  doneActivities,
}) => {
  /**
   * This function is used to detect first ondone activity by comparing
   * the first coachable_id that is not in the doneActivities object.
   */
  const currentActivity = wwtkItems
    && wwtkItems.find(({ coachable_id, campaign_id }) => !doneActivities.includes(
      JSON.stringify({ coachableId: coachable_id, campaignId: campaign_id })
    ));
  /**
   * Check wheather all activities are done.
   */
  const isAllDone = wwtkItems && isArraysEqual(
    wwtkItems.map(({ coachable_id, campaign_id }) => JSON.stringify(
      { coachableId: coachable_id, campaignId: campaign_id }
    )),
    doneActivities
  );

  useEffect(() => {
    if (isAllDone) {
      eventTracker(
        events.HOME_SCREEN_WWTK_DONE,
        { activity_count: wwtkItems.length }
      );
    }
  }, [isAllDone, currentActivity]);

  if (!wwtkItems) return null;

  return (
    <Container>
      <Title>
        {_('resources.we_wanted_to_know')}
      </Title>
      <Context>
        {
          isAllDone
          && !currentActivity
          && (
            <FinishText style={{ fontSize: '16px', marginTop: '40px' }}>
              {_('resources.thanks_for_participating')}
            </FinishText>
          )
        }
        {
          !isAllDone
          && currentActivity
          && (activities[currentActivity.type](currentActivity))
        }
      </Context>
    </Container>
  );
};

export default connect(
  (store) => ({
    wwtkItems: store.education.wwtk_items || null,
    doneActivities: store.wwtk.doneActivities || [],
    selectedLang: store.config.selectedLang,
  })
)(WWTK);
